import DSFieldRecord from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import I18n from 'I18n';
import { ENUMERATION } from 'customer-data-objects/property/PropertyTypes';
import { EVENT_BASED_FIELD_KEYS } from 'customer-data-filters-ui/strategy/eventBasedFilters';
import { SITE_CONTENT } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { EnumerationDisplayType } from '../../filterQueryFormat/DisplayTypes';
export const makeEventPageField = filterFamily => {
  return DSFieldRecord({
    displayType: EnumerationDisplayType,
    label: I18n.text(`newCustomerDataFilters.specialFields.${filterFamily}.${EVENT_BASED_FIELD_KEYS.EVENT_PAGE}`),
    name: EVENT_BASED_FIELD_KEYS.EVENT_PAGE,
    type: ENUMERATION,
    referencedObjectType: SITE_CONTENT,
    displayOrder: 0
  });
};